import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import pathRouts from '../enums/pathRoute';
import verbsTypes from '../enums/verbsTypes';
import { reportToLrs } from '../utils/reportToLrs';

const useLrsReport = (objectId, objectName = null, isAppLevel = false, enabled = true) => {
    
    const { isAuth } = useSelector(state => state.auth);

    useEffect(() => {
        if (enabled && isRouteShouldFetch() && isAuth) {
            // const startTime = Date.now();

            const handleEnter = () => {
                reportToLrs({ verbId: verbsTypes.ENTER, objectId, objectName });
            };



            handleEnter();

            // const handleExit = () => {
            //     const endTime = Date.now();
            //     const durationInSeconds = Math.round((endTime - startTime) / 1000);
            //     reportToLrs({ verbId: verbsTypes.EXIT, objectId, objectName, duration: durationInSeconds });
            // };

            // if (isAppLevel) {
            //     window.addEventListener('beforeunload', handleExit);
            // }

            // return () => {
            //     if (isAppLevel) {
            //         window.removeEventListener('beforeunload', handleExit);
            //         return;
            //     }
            //     handleExit();
            // };
        }
        //react-hooks/exhaustive-deps
    }, [objectId, isAppLevel, objectName, enabled, isAuth]);
};

export default useLrsReport;

const isRouteShouldFetch = () => {
    return !window.location.pathname.includes(pathRouts.DELAYNAVIGATE);
};
